"use client"

import { Button } from "@/components/ui/button"
import { Pencil } from "lucide-react"

export default function EditCommentButton({
  onClick,
  isDisabled,
}: {
  onClick?: () => void
  isDisabled?: boolean
}) {
  return (
    <Button
      variant="ghost"
      onClick={() => onClick?.()}
      className="px-2"
      disabled={isDisabled}
    >
      <Pencil className="w-4 h-4 text-muted-foreground" />
    </Button>
  )
}
